import { Component, OnInit, Input } from '@angular/core';
import { LendiProductRecord } from 'src/class/product.model';

@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.css']
})
export class ProductCardComponent implements OnInit {

  @Input() productRecord: LendiProductRecord;
  productStatus = '';

  constructor() { }

  ngOnInit() {
  }

}
